const jsonSchema = [
  {
    name: 'dayOfWeek',
    label: 'Day of week',
    type: 'multiselect',
    isMulti: false,
    options: [{ label: 'Monday', value: 'MONDAY' }, { label: 'Tuesday', value: 'TUESDAY' }, { label: 'Wednesday', value: 'WEDNESDAY' }, { label: 'Thursday', value: 'THURSDAY' }, { label: 'Friday', value: 'FRIDAY' }, { label: 'Saturday', value: 'SATURDAY' }, { label: 'Sunday', value: 'SUNDAY' }],
    required: true,
    showInList: true
  },
  {
    type: 'group',
    fields: [

      {
        name: 'coach',
        label: 'Coach',
        type: 'text',
        required: true,
        showInList: true
      },
      {
        name: 'room',
        label: 'Room',
        type: 'text',
        required: true,
        showInList: true
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'maxCapacity',
        label: 'Max Capacity',
        type: 'number',
        required: true,
        showInList: false
      },
      {
        name: 'color',
        label: 'Color',
        type: 'text',
        required: true,
        showInList: false
      },
      {
        name: 'cancellationPolicyHours',
        label: 'Cancellation Policy (hours)',
        type: 'number',
        required: true,
        showInList: false
      }
    ]
  }
  // Add more fields as needed
];
export default jsonSchema;
